"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1({ refetchFn, isRefetching = false, additionalDeps = [], }) {
    const [isRefreshing, setIsRefreshing] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isRefetching) {
            if (isRefreshing) {
                window.setTimeout(() => setIsRefreshing(false), 1000);
            }
        }
    }, [isRefetching]);
    const [refreshDiv, setRefreshDiv] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!!refreshDiv) {
            let isScrollTop = false;
            let startY;
            let pullDistance;
            const onTouchStart = (e) => {
                if (refreshDiv.scrollTop <= 10) {
                    isScrollTop = true;
                    refreshDiv.style.transition = '0.3s';
                    startY = e.touches[0].clientY;
                }
            };
            const onTouchEnd = () => __awaiter(this, void 0, void 0, function* () {
                const removeStyle = () => refreshDiv.removeAttribute('style');
                if (isScrollTop && pullDistance >= 40) {
                    setIsRefreshing(true);
                    removeStyle();
                    refetchFn();
                }
                else {
                    refreshDiv.style.transform = 'translateY(0px)';
                    window.setTimeout(removeStyle, 500);
                }
                isScrollTop = false;
                pullDistance = 0;
            });
            const onTouchMove = (e) => {
                const moveY = e.touches[0].clientY;
                pullDistance = Math.min((moveY - startY) / 3, 40);
                if (isScrollTop && pullDistance > 0) {
                    e.stopPropagation();
                    e.preventDefault();
                    refreshDiv.style.transform = `translateY(${pullDistance}px)`;
                }
            };
            refreshDiv.addEventListener('touchstart', onTouchStart);
            refreshDiv.addEventListener('touchend', onTouchEnd);
            refreshDiv.addEventListener('touchmove', onTouchMove);
            return () => {
                refreshDiv.removeEventListener('touchstart', onTouchStart);
                refreshDiv.removeEventListener('touchend', onTouchEnd);
                refreshDiv.removeEventListener('touchmove', onTouchMove);
            };
        }
    }, [refreshDiv, ...additionalDeps]);
    return { isRefreshing, setRefreshDiv };
}
exports.default = default_1;
